import {split} from 'lodash';

export const translateRecipients = (schedule) => {

  if (!schedule) {
    return {
      to: [],
      cc: [],
      bcc: []
    };
  }

  const {recipientToAddress, recipientCCAddress, recipientBCCAddress} = schedule;
  const to = recipientToAddress ? split(recipientToAddress, ',') : [];
  const cc = recipientCCAddress ? split(recipientCCAddress, ',') : [];
  const bcc = recipientBCCAddress ? split(recipientBCCAddress, ',') : [];

  return {to, cc, bcc};

};



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/report-edit/recipients.js